module.exports = __webpack_public_path__ + "static/media/mailchimp_icon.6e5bb481.svg";